/**
 * @generated SignedSource<<c3da0476239dd1ff7f197172ff900483>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HomeWidgetState = "COLLAPSED" | "EXPANDED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHomeWidgetStateUserPreferencesFragment$data = {
  readonly __typename: "UserPreferences";
  readonly homeWidgets: ReadonlyArray<{
    readonly __typename: "HomeWidget";
    readonly id: string;
    readonly state: HomeWidgetState;
  }>;
  readonly " $fragmentType": "useHomeWidgetStateUserPreferencesFragment";
};
export type useHomeWidgetStateUserPreferencesFragment$key = {
  readonly " $data"?: useHomeWidgetStateUserPreferencesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHomeWidgetStateUserPreferencesFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useHomeWidgetStateUserPreferencesFragment",
  "selections": [
    {
      "concreteType": "HomeWidget",
      "kind": "LinkedField",
      "name": "homeWidgets",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "state"
        },
        (v0/*: any*/)
      ]
    },
    (v0/*: any*/)
  ],
  "type": "UserPreferences"
};
})();

(node as any).hash = "0c62eafb1ea633f1257ca52f851d7e59";

export default node;
